import "./App.css"
import {Route, Routes} from "react-router-dom"
import About from "./pages/About";
import Home from "./pages/Home";
import NavBar from "./pages/Navbar";
import Projects from "./pages/Projects";

function App() {
  return (
    <div className="app">
      <NavBar />
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />}/>
      </Routes>
    </div>
  );
}

export default App;
